import { Timestamp } from 'google-protobuf/google/protobuf/timestamp_pb.js';

/** Converte google.protobuf.Timestamp (grpc-web) para ISO 8601 UTC (RFC3339). */
export function timestampToISO(ts) {
    if (ts == null) {
        return null;
    }

    let seconds;
    let nanos = 0;

    if (typeof ts.getSeconds === 'function') {
        seconds = ts.getSeconds();
        nanos = ts.getNanos() || 0;
    } else if (typeof ts === 'object') {
        seconds = ts.seconds ?? ts[1];
        nanos = ts.nanos ?? ts[2] ?? 0;
    } else {
        return null;
    }

    if (seconds == null || seconds === '') {
        return null;
    }
    const sec = Number(seconds);
    const ms = sec * 1000 + Math.floor(Number(nanos) / 1e6);
    if (!Number.isFinite(ms)) {
        return null;
    }
    return new Date(ms).toISOString();
}

/** yyyy-MM-dd em UTC (ex.: gráfico do dashboard). */
export function timestampToDateString(ts) {
    const iso = timestampToISO(ts);
    if (!iso) {
        return '';
    }
    return iso.slice(0, 10);
}

/** Converte yyyy-MM-dd local (filtro) para Timestamp proto (UTC meia-noite). */
export function dateStringToTimestamp(dateStr) {
    if (!dateStr || typeof dateStr !== 'string') {
        return null;
    }
    const trimmed = dateStr.trim();
    if (!/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
        return null;
    }
    const instant = new Date(`${trimmed}T00:00:00.000Z`);
    const ts = new Timestamp();
    ts.setSeconds(Math.floor(instant.getTime() / 1000));
    ts.setNanos((instant.getTime() % 1000) * 1e6);
    return ts;
}

/** Converte ISO / datetime string para Timestamp proto (UTC). */
export function isoToTimestamp(iso) {
    if (!iso) {
        return null;
    }
    const instant = new Date(iso);
    if (Number.isNaN(instant.getTime())) {
        return null;
    }
    const ts = new Timestamp();
    ts.setSeconds(Math.floor(instant.getTime() / 1000));
    ts.setNanos((instant.getTime() % 1000) * 1e6);
    return ts;
}

/** Aplica timestampToISO em campos conhecidos de um objeto plano. */
export function mapTimestamps(obj, fields) {
    if (!obj || typeof obj !== 'object') {
        return obj;
    }
    const out = { ...obj };
    fields.forEach((field) => {
        if (out[field] && typeof out[field].getSeconds === 'function') {
            out[field] = timestampToISO(out[field]);
        }
    });
    return out;
}
